import React from 'react';
import { Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';

const AddressCell = ({ loading, unloading, fontSize = 14 }) => {
  const loadingText = loading || '-';
  const unloadingText = unloading || '-';

  return (
    <Tooltip
      title={
        <>
          <b>Lokasi Muat</b>
          <br />
          {loadingText}
          <br />
          <br />
          <b>Lokasi Bongkar</b>
          <br />
          {unloadingText}
        </>
      }
      arrow
      placement='top-start'>
      <div className='order-address-cell'>
        <div className='order-address-cell__row'>
          <Icon
            icon='solar:box-bold'
            width={16}
            className='order-address-cell__icon is-load'
          />
          <p
            className='order-address-cell__text'
            style={{ fontSize }}>
            <b>Lokasi Muat:</b> {loadingText}
          </p>
        </div>
        <div className='order-address-cell__row'>
          <Icon
            icon='solar:map-point-bold'
            width={16}
            className='order-address-cell__icon is-unload'
          />
          <p
            className='order-address-cell__text'
            style={{ fontSize }}>
            <b>Lokasi Bongkar:</b> {unloadingText}
          </p>
        </div>
      </div>
    </Tooltip>
  );
};

export default AddressCell;
